module.exports = __webpack_public_path__ + "components/app-store/static/s9-8e56b9e3220fae3f25bfad5dfa139e20.jpg";